<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('analytics.title')}}</h2>
        <div class="irinox-form analytics-form" >
          <TabView lazy>
            <TabPanel v-if="!role.includes('SERVICE')" :header="$t('analytics.tab_laboratories')">
              <Laboratories/>
            </TabPanel>
            <TabPanel :header="$t('analytics.tab_devices')">
              <Devices/>
            </TabPanel>
          </TabView>
        </div>
		</div>
	</div>

</template>

<script>
import { mapGetters } from 'vuex';
import Laboratories from './Laboratories.vue';
import Devices from './Devices.vue';

export default {
  
    components: {
      Laboratories,
      Devices
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters({
          role: 'userdata/role',
        }),
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style>

</style>